import { matchSorter } from './../../../../ext/match-sorter/dist/match-sorter.esm.js';

const teamOptionSort = (a, b) => {
    const [x, aService, aTeam] = a.order;
    const [y, bService, bTeam] = b.order;
    return x - y || aService.localeCompare(bService) || aTeam.localeCompare(bTeam);
};
const groupTeamOptions = (options, searchTerm) => matchSorter(options, searchTerm, {
    keys: ["name"],
    threshold: matchSorter.rankings.CONTAINS,
})
    .sort(teamOptionSort)
    .reduce((acc, option) => {
    var _a;
    acc[_a = option.group] || (acc[_a] = []);
    acc[option.group].push(option);
    return acc;
}, {});

export { groupTeamOptions };
//# sourceMappingURL=index.js.map
